/**
 * 封面延迟直传(_shared C-4 正向差异)。
 * 时序:守卫全过后 → 取 cover-upload-credential(需 KYC_VERIFIED)→ 对预签名 uploadUrl 做**裸 PUT**
 * (原始字节;**不经 envelope apiClient 拦截器** —— 目标是 MinIO/S3 非本站 API)→ 用 finalUrl。
 */
import { getCoverUploadCredential } from '@/api/products';

export async function uploadCover(file: File): Promise<string> {
  const cred = await getCoverUploadCredential();
  if (!cred.uploadUrl || !cred.finalUrl) {
    throw new Error('封面上传凭证获取失败');
  }
  const res = await fetch(cred.uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': file.type || 'image/jpeg' },
  });
  if (!res.ok) {
    throw new Error(`封面上传失败(${res.status})`);
  }
  return cred.finalUrl;
}
